import util from '@/tools/commonUtil'
export default {
  id: '',
  groupId: '',
  belongId: '',
  isRequired: '1',
  orderById: 100,
  elementType: 'MultiFillBlankBox',
  elementDesc: '多行填空',
  type: 'multifillblankbox',
  // 是否可配置
  config: true,
  title: '多项填空',
  placeholder: '多项填空',
  itemName: 'optionList',
  imgUrl: '',
  imgName: '',
  optionList: [],
  vertical: true,
  value: [],
  ruleError: '该字段不能为空',
  saveCb (data) {
    this.optionList = util.genRetList.call(this, data.optionList, 'option', {value: ''})
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      orderyNum: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/MultiFillBlankBox/config.js